/*
  Bundle builder: start with the product the customer came from.
  The product page's bundle block links to the builder with ?hs_kies=<variant id>.
  Here we press Juo's own "Voeg toe aan bundel" button for that variant, so Juo
  keeps owning the box, the discount and the progress bar.

  Marcel 18-10: the product must visibly land in the selection, for every type.
  The builder opens on step 1 (Haar > Shampoo Bars) and Juo hides every card
  outside the active collection, so a deodorant was added but invisible. We now
  first switch the step bar to the step that holds the card (through the step
  bar's own buttons, never Juo's hidden filters — see hs-juo-bab-steps.js), then
  add, then scroll the card into view.

  Order matters: Juo restores the box (cart, else localStorage) after an async
  cart.json fetch and then fires juo-box:updated:state; the steps script clicks
  step 1 on DOMContentLoaded. We wait for both, so neither undoes our work.
  Cards are server-rendered, so a missing button means the variant is sold out
  or not (yet) in Juo's box list — we say so instead of failing silently.
  The parameter is removed afterwards.

  hs_abo=1 (the "Abonneer en bespaar" button in the product page's bundle block,
  Marcel 19-10): after adding, tick Juo's own subscribe box (#juo-box-subscribe)
  so the visitor lands in the subscription with the product already chosen
  (end-to-end checked 19-10: product + subscribe tick + cart line with selling plan).
*/
;(function () {
  var params = new URLSearchParams(window.location.search);
  var id = params.get('hs_kies');
  if (!id || !/^\d+$/.test(id)) return;
  var abo = params.get('hs_abo') === '1';

  function opruimen() {
    params.delete('hs_kies');
    params.delete('hs_abo');
    var q = params.toString();
    try { history.replaceState(history.state, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash); } catch (e) {}
  }

  function melding(tekst) {
    var el = document.createElement('div');
    el.className = 'hs-bv-melding';
    el.setAttribute('role', 'status');
    el.textContent = tekst;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-zichtbaar'); });
    setTimeout(function () {
      el.classList.remove('is-zichtbaar');
      setTimeout(function () { el.remove(); }, 400);
    }, 5000);
  }

  function boxData() {
    var el = document.getElementById('juo-box-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function knopVoor(variantId) {
    // Scoped to the product grid: Juo's details modal has an add button for the same variant.
    return document.querySelector('.box-builder__products-list [data-add-to-box][data-variant-id="' + variantId + '"]');
  }

  function kaartVan(knop) { return knop.closest('[data-box-item]'); }

  function zitAlInBox(knop) {
    var kaart = kaartVan(knop);
    if (kaart && kaart.classList.contains('in-cart')) return true;
    try {
      var box = JSON.parse(localStorage.getItem('juo-box-products') || '[]');
      return box.some(function (p) { return String(p.variantId) === id; });
    } catch (e) { return false; }
  }

  function naamVan(knop) {
    var kaart = kaartVan(knop);
    var kop = kaart && kaart.querySelector('.product-title');
    var variant = kaart && kaart.querySelector('.product-variant-title');
    var naam = kop ? kop.textContent.replace(/\s+/g, ' ').trim() : '';
    var v = variant ? variant.textContent.replace(/\s+/g, ' ').trim() : '';
    return v && v !== 'Default Title' ? naam + ' – ' + v : naam;
  }

  function stappenKlaar() {
    // No step bar on the page: nothing to wait for.
    if (!document.querySelector('[data-bab-step-tab]')) return true;
    return !!document.querySelector('.hs-juo-top-level-item.hs-is-active-item');
  }

  // First step (in step-bar order) with a sub-collection that holds the card.
  function vindStap(kaart) {
    var ids;
    try { ids = JSON.parse(kaart.getAttribute('data-filter') || '[]').map(String); } catch (e) { ids = []; }
    var tabs = document.querySelectorAll('button[data-bab-step-tab][data-step-id]');
    for (var i = 0; i < tabs.length; i++) {
      var li = tabs[i].closest('.hs-juo-top-level-item');
      var cols = li ? li.querySelectorAll('.hs-juo-sub-level-bar button[data-collection-id]') : [];
      for (var j = 0; j < cols.length; j++) {
        if (ids.indexOf(cols[j].getAttribute('data-collection-id')) !== -1) return { tab: tabs[i], li: li, col: cols[j] };
      }
    }
    return null;
  }

  function toonKaart(kaart) {
    var doel = vindStap(kaart);
    if (doel) {
      // Tab: activates the step and its first collection; sub button: the card's own collection.
      if (!doel.li.classList.contains('hs-is-active-item')) doel.tab.click();
      doel.col.click();
    } else {
      // In no step: show it in the current grid until the visitor changes step.
      kaart.classList.remove('hidden');
    }
    requestAnimationFrame(function () {
      var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      kaart.scrollIntoView({ behavior: rustig ? 'auto' : 'smooth', block: 'center' });
      if (doel) {
        // Phones: the sub bar scrolls sideways, bring the active collection into view.
        var bar = doel.col.closest('.hs-juo-sub-level-bar');
        if (bar && bar.scrollWidth > bar.clientWidth) bar.scrollLeft = Math.max(0, doel.col.offsetLeft - (bar.clientWidth - doel.col.offsetWidth) / 2);
      }
    });
  }

  // Juo listens to the checkbox itself; a click sets checked and fires its change handling.
  function abonnementAan() {
    var vink = document.getElementById('juo-box-subscribe');
    if (!vink || vink.disabled) return false;
    if (!vink.checked) vink.click();
    return vink.checked;
  }

  function toevoegen(knop) {
    var naam = naamVan(knop), gemeld = false;
    function meld(al) {
      if (gemeld) return;
      gemeld = true;
      var metAbo = abo && abonnementAan();
      if (!naam) return;
      melding(al
        ? naam + (metAbo ? ' zit al in je bundel; je abonnement staat aan.' : ' zit al in je bundel.')
        : naam + (metAbo ? ' zit in je bundel, met abonnement.' : ' zit in je bundel.') + ' Kies er meer bij voor extra korting.');
    }
    if (zitAlInBox(knop)) meld(true); else knop.click();
    // Check a few times: right after a new release the first visitor's click could miss or be undone
    // while Juo was still starting (1 run in 6 on a phone, 19-10). Idempotent: only clicks when missing.
    [700, 1500, 3000, 6000].forEach(function (ms) {
      setTimeout(function () {
        if (!zitAlInBox(knop)) knop.click();
        setTimeout(function () {
          if (!zitAlInBox(knop)) return;
          meld(false);
          if (abo) abonnementAan();
        }, 400);
      }, ms);
    });
  }

  var knop = knopVoor(id);
  opruimen();

  if (!knop) {
    // Server-rendered grid: no button = sold out or not in Juo's box list.
    var d = boxData();
    var inLijst = d && d.ids && d.ids.map(String).indexOf(id) !== -1;
    melding(inLijst
      ? 'Dit product is even uitverkocht. Kies hieronder je favorieten voor je bundel.'
      : 'Dit product kun je nog niet in een bundel kiezen. Kies hieronder je favorieten.');
    return;
  }
  if (knop.disabled || knop.getAttribute('aria-disabled') === 'true') return;

  var klaar = false, gestart = false, pogingen = 0;
  document.addEventListener('juo-box:updated:state', function () { klaar = true; }, { once: true });
  // Fallback when the restore event already fired or never comes (slow phones: give it time).
  setTimeout(function () { klaar = true; }, 6000);

  (function wacht() {
    if (gestart) return;
    if (!(klaar && stappenKlaar())) {
      if (++pogingen < 80) return setTimeout(wacht, 125);
    }
    gestart = true;
    var kaart = kaartVan(knop);
    if (kaart) toonKaart(kaart);
    setTimeout(function () { toevoegen(knop); }, 200);
  })();
})();
